import { InfoTip } from './InfoTip';
import styles from './Bar.module.css';

interface BarProps {
  label: string;
  value: number;
  max: number;
  color?: string;
  format?: (n: number) => string;
  tooltip?: string;
}

export function Bar({ label, value, max, color = 'var(--color-primary)', format, tooltip }: BarProps) {
  const pct = max > 0 ? Math.min(100, (value / max) * 100) : 0;
  const display = format ? format(value) : String(value);

  return (
    <div className={styles.row}>
      <span className={styles.label}>{label}{tooltip && <InfoTip text={tooltip} position="right" />}</span>
      <div className={styles.track}>
        <div
          className={styles.fill}
          style={{ width: `${pct}%`, background: color }}
        />
      </div>
      <span className={styles.value}>{display}</span>
    </div>
  );
}
